module.exports = __webpack_public_path__ + "img/Read.ea8ee400.svg";